import { RouteName } from '@mews-commander/enums';
import { CommanderThunkAction, WithProfileId } from '@mews-commander/types';
import { getCurrentScopeProfileId } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { getScopeEnterpriseId } from '@mews-commander/legacy-entities/src/ducks/scopes';
import { openModal } from '../../app/actions/common';
import { changeEnterprise } from '../../app/actions/profile';

export interface OpenTaskDetailParams extends WithProfileId {
    taskId: string;
}

export const openTaskDetail = ({ taskId, profileId }: OpenTaskDetailParams) =>
    changeAccountIfNeeded({ profileId, routeName: RouteName.TaskDetail, params: { taskId } });

export const openNotification = ({ id, profileId }: { id: string; profileId: string }) =>
    changeAccountIfNeeded({ profileId, routeName: RouteName.NotificationVisit, params: { id } });

export const openMessages = (profileId: string) =>
    changeAccountIfNeeded({ profileId, routeName: RouteName.MessageThreadIndex });

const changeAccountIfNeeded =
    ({
        profileId,
        routeName,
        params,
    }: {
        profileId: string;
        routeName: RouteName;
        params?: {};
    }): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const state = getState();
        const currentProfileId = getCurrentScopeProfileId(state);
        if (profileId === currentProfileId) {
            const url = resolveRoute(routeName, params);
            return dispatch(openModal(url));
        }

        // @ts-expect-error $TSFixMeError: Expected 1 arguments, but got 2.
        const enterpriseId = getScopeEnterpriseId(state, { profileId });
        const url = resolveRoute(routeName, {
            ...params,
            currentEnterpriseId: enterpriseId,
        });

        return dispatch(changeEnterprise({ profileId, enterpriseId }, url));
    };
